/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

class FinAiAgentSalesDeployEmailRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.appService.app.canUseFeature('sdr-information-architecture-change')) {
      this.router.transitionTo('apps.app');
    }
  }

  get titleToken() {
    return this.intl.t('ai-agent.deploy.sales.email');
  }

  reactEnabled() {
    return this.appService.app.canUseFeature('sdr-information-architecture-change');
  }
}

export default ReactRoute(FinAiAgentSalesDeployEmailRoute);
